/**
 * Shared post-Set behavior for EGMs admin pages (Manufacturers / Game Names).
 * After a successful mapping update: stay on the current tab, keep search/sort,
 * refresh data, and restore IonContent scroll when feasible.
 */

export type IonScrollContent = {
  getScrollElement?: () => Promise<HTMLElement>;
  scrollToPoint?: (x: number, y: number, duration?: number) => Promise<void> | void;
};

/** Never switch tabs after Set — caller must leave `tab` state unchanged. */
export function shouldSwitchTabAfterSuccessfulSet(): boolean {
  return false;
}

/**
 * Run a list refresh while restoring the previous IonContent scrollTop.
 * Failures reading/writing scroll are ignored so refresh still completes.
 */
export async function refreshKeepingIonScroll(
  content: IonScrollContent | null | undefined,
  refresh: () => Promise<void>
): Promise<number> {
  let top = 0;
  try {
    if (content?.getScrollElement) {
      const el = await content.getScrollElement();
      top = el?.scrollTop ?? 0;
    }
  } catch {
    top = 0;
  }
  await refresh();
  try {
    if (content?.scrollToPoint) {
      await content.scrollToPoint(0, top, 0);
    }
  } catch {
    // ignore scroll restore errors
  }
  return top;
}
